__turbopack_context__.v({
  "className": "ibm_plex_sans_70e1a575-module__Qrhz8W__className",
  "variable": "ibm_plex_sans_70e1a575-module__Qrhz8W__variable",
});
